import type { MerchantReportRiskLevel } from '@ballerine/common';
import { titleCase } from 'string-ts';

const getRiskLevelGradientColorPair = (riskLevel: MerchantReportRiskLevel | null | undefined) => {
  if (!riskLevel) {
    return { from: '#A0AEC0', to: '#718096' };
  }

  switch (riskLevel) {
    case 'low':
      return { from: '#00BD59', to: '#009D4A' };
    case 'medium':
      return { from: '#FFB35A', to: '#F1870A' };
    case 'high':
      return { from: '#FF7300', to: '#E44800' };
    case 'critical':
      return { from: '#FF3300', to: '#A60000' };
    default:
      return { from: '#A0AEC0', to: '#718096' };
  }
};

export const Hexagon: React.FC<{
  className?: string;
  riskLevel?: MerchantReportRiskLevel | null;
}> = ({ className, riskLevel }) => {
  const { from, to } = getRiskLevelGradientColorPair(riskLevel);

  return (
    <svg
      width="123"
      height="131"
      viewBox="0 0 123 131"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_d_hexagon)">
        <path
          d="M5 36.9321C5 30.5914 8.61473 24.8055 14.3132 22.0249L54.226 2.54936C58.8167 0.309342 64.1833 0.309342 68.774 2.54936L108.687 22.0249C114.385 24.8055 118 30.5914 118 36.9321V86.5083C118 92.849 114.385 98.6349 108.687 101.415L68.774 120.891C64.1833 123.131 58.8167 123.131 54.226 120.891L14.3132 101.415C8.61473 98.6349 5 92.849 5 86.5083V36.9321Z"
          fill="url(#linear_gradient_hexagon)"
        />
      </g>
      {riskLevel && (
        <>
          <text
            x="61.5"
            y="50"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="white"
            fontWeight="bold"
            fontSize="24"
          >
            {titleCase(riskLevel)}
          </text>
          <text
            x="61.5"
            y="80"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="white"
            fontWeight="bold"
            fontSize="24"
          >
            Risk
          </text>
        </>
      )}
      <defs>
        <filter
          id="filter0_d_hexagon"
          x="0.85"
          y="0.87"
          width="121.3"
          height="130"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values={`0 0 0 0 ${parseInt(from.substring(1, 3), 16) / 255} 0 0 0 0 ${parseInt(from.substring(3, 5), 16) / 255} 0 0 0 0 ${parseInt(from.substring(5, 7), 16) / 255} 0 0 0 0.3 0`}
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_hexagon" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_hexagon"
            result="shape"
          />
        </filter>
        <linearGradient
          id="linear_gradient_hexagon"
          x1="61.5"
          y1="0"
          x2="61.5"
          y2="124"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
    </svg>
  );
};
